import { useRef, useState } from 'react';

import { useCompanyPartsActions } from 'partsOld/hooks';
import { ICompanyPart } from 'partsOld/types';
import { PricingType } from 'pricing/enums';

import ManualPriceFieldsView from './ManualPriceFieldsView';

interface IProps {
  part: Partial<ICompanyPart>;
  priceValue: string;
  uomValue: string;
  field: string;
}

const ManualPriceFields = ({ priceValue, uomValue, field, part }: IProps) => {
  const priceRef = useRef(priceValue);
  const uomRef = useRef(uomValue);

  const [price, setPrice] = useState(priceValue);
  const [uom, setUom] = useState(uomValue);

  const { upsertCompanyPart } = useCompanyPartsActions();

  const edit = async () => {
    const corporatePart = {
      id: part?.id,
      pricingType: PricingType.MANUAL,
      [field]: price,
      [`${field}Uom`]: uom,
    };

    await upsertCompanyPart(corporatePart);
  };

  const onBlur = (value: string, refValue: React.MutableRefObject<string>) => {
    if (refValue.current !== value) {
      refValue.current = value;

      edit();
    }
  };

  return (
    <ManualPriceFieldsView
      onBlur={onBlur}
      setPrice={setPrice}
      setUom={setUom}
      price={price}
      uom={uom}
      priceRef={priceRef}
      uomRef={uomRef}
    />
  );
};

export default ManualPriceFields;
